module.exports = __webpack_public_path__ + "img/logo-soi.bd3de0ea.png";